export default __webpack_public_path__ + "static/media/IBMPlexSans-MediumItalic.4d70bd8f.woff";